<div *ngIf="isLoading">
  <div id="preloader">
    <div id="loader" class="loader">
      <div class="loader-container">
        <div class="loader-icon" *ngIf="portalConfig?.portalLogoUrl">
          <img
            [src]="portalConfig?.portalLogoUrl"
            alt="Preloader"
            class="preloader-logo"
          />
        </div>
      </div>
    </div>
  </div>
</div>
